<app-split [id]="splitComponentId" (componentClose)="onAnnexPanelClose()">
<div>
  <div class="content-card">
    <div fxLayout="row" fxLayoutAlign="center center" class="content">
      <div class="example-container">
        <div fxLayout="row" class="action-panel" [visibleWithPermissions]="['ManageAllExternalWorkersList', 'ManageMyExternalWorkersList']">
          @if (!isSelfProfile()) {
          <button mat-raised-button color="primary" [matMenuTriggerFor]="menu">
            {{ 'WL-AddWorkerAgreement' | translate }}
          </button>
          }
          <mat-menu #menu="matMenu" class="add-agreement-menu">
            <div
              [matTooltip]="
                !isAddAgreementButtonEnabled(EmploymentType.EmploymentAgreement) ? ('YouHaveNotEnabledEmploymentAgreement' | translate) : ''
              "
              matTooltipClass="agreements-tooltip"
            >
              <button
                mat-menu-item
                [disabled]="!isAddAgreementButtonEnabled(EmploymentType.EmploymentAgreement)"
                (click)="onAddAgreementClick(EmploymentType.EmploymentAgreement)"
              >
                {{ 'WL-AddAgreementOfEmployment' | translate }}
              </button>
            </div>
            <div
              [matTooltip]="
                !isAddAgreementButtonEnabled(EmploymentType.TemporaryEmploymentAgreement)
                  ? ('YouHaveNotEnabledTemporaryEmploymentAgreement' | translate)
                  : ''
              "
              matTooltipClass="agreements-tooltip"
            >
              <button
                mat-menu-item
                [disabled]="!isAddAgreementButtonEnabled(EmploymentType.TemporaryEmploymentAgreement)"
                (click)="onAddAgreementClick(EmploymentType.TemporaryEmploymentAgreement)"
              >
                {{ 'WL-AddAgreementOfTemporaryEmployment' | translate }}
              </button>
            </div>
            <div
              [matTooltip]="!isAddAgreementButtonEnabled(EmploymentType.MandateAgreement) ? ('YouHaveNotEnabledMandateAgreement' | translate) : ''"
              matTooltipClass="agreements-tooltip"
            >
              <button
                mat-menu-item
                [disabled]="!isAddAgreementButtonEnabled(EmploymentType.MandateAgreement)"
                (click)="onAddAgreementClick(EmploymentType.MandateAgreement)"
              >
                {{ 'WL-AddAgreementOfMandate' | translate }}
              </button>
            </div>
            <div
              [matTooltip]="
                !isAddAgreementButtonEnabled(EmploymentType.TemporaryMandateAgreement) ? ('YouHaveNotEnabledMandateAgreement' | translate) : ''
              "
              matTooltipClass="agreements-tooltip"
            >
              <button
                mat-menu-item
                [disabled]="!isAddAgreementButtonEnabled(EmploymentType.TemporaryMandateAgreement)"
                (click)="onAddAgreementClick(EmploymentType.TemporaryMandateAgreement)"
              >
                {{ 'WL-AddTemporaryMandateAgreement' | translate }}
              </button>
            </div>
          </mat-menu>
        </div>
        <div class="table-wrapper custom-table">
          <mat-table
            #table
            matSort
            matSortActive="AgreementStartDate"
            matSortDirection="desc"
            matSortDisableClear
            [dataSource]="(dataSource.agreements$ | async) ?? []"
          >
            <ng-container matColumnDef="EmployerName">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'Employer' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.EmployerName }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="EmploymentType">
              <mat-header-cell *matHeaderCellDef mat-sort-header="EmploymentTypeId" class="hidden-sort">
                {{ 'WL-EmploymentType' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.EmploymentType }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="AgreementType">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'WL-AgreementType' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.AgreementType }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="AgreementStartDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'WL-AgreementStartDate' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.AgreementStartDate | date : 'yyyy-MM-dd' }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="AgreementEndEffectiveDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'WL-AgreementEndDate' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.AgreementEndEffectiveDate | date : 'yyyy-MM-dd' }}
                @if (element.AgreementTerminationEndDate) {
                <mat-icon
                  class="material-icons-outlined"
                  [matTooltip]="createAgreementEndDateTooltipText(element)"
                  matTooltipClass="agreements-tooltip"
                  >info</mat-icon
                >
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="AgreementConclusionDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'AgreementConclusionDate' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.AgreementConclusionDate | date : 'yyyy-MM-dd' }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Status">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'Status' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.StatusName }}
                @if (element.LegalizationStatusId) {
                <div [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']">
                  <app-legalization-status-info [element]="element" [showTooltip]="true"></app-legalization-status-info>
                </div>
                }
                <app-annex-badge
                  [annexCount]="element.AnnexCount"
                  [lastSignedAnnexDate]="element.LastSignedAnnexDate"
                  [hasUnsignedAnnex]="element.HasUnsignedAnnex"
                  [hasInconsistentAnnex]="element.HasInconsistentAnnex"
                  [isAdmin]="isAdmin"
                />
                <app-annex-imported-badge [visible]="element.HasImportedAnnex" />
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Actions" stickyEnd>
              <mat-header-cell *matHeaderCellDef class="hidden-sort"
                >{{ 'WAD-Actions' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                <div fxLayout="row">
                  @if (!isEmployee || (isEmployee && !isSelfProfile())) {
                  <mat-menu #employeeActionsMenu="matMenu">
                    @if (isEditAgreementButtonVisible(element.Status)) {
                    <button mat-menu-item (click)="onEditAgreementClick(element)">
                      <mat-icon>edit</mat-icon>
                      {{ 'WL-EditWorkerAgreement' | translate }}
                    </button>
                    } @if (!isWaitingForGenerationStatus(element.Status)) {
                    <button
                      mat-menu-item
                      [routerLink]="[
                        '/workers',
                        element.WorkerId,
                        'employmentType',
                        element.EmploymentTypeId,
                        'agreements',
                        element.AgreementId,
                        'details'
                      ]"
                      [visibleWithPermissionsOnWorkerProfile]="['ManageMyExternalWorkersList', 'ViewAllExternalWorkers', 'ViewWorkerAgreementDetails']"
                      [authServerUserId]="authServerUserId"
                    >
                      <mat-icon>visibility</mat-icon>
                      {{ 'WL-WorkerAgreementDetails' | translate }}
                    </button>
                    } @if (isDeleteAgreementButtonVisible()) {
                    <div [matTooltip]="deleteAgreementButtonTooltip(element)" matTooltipClass="agreements-tooltip">
                      <button mat-menu-item [disabled]="!isDeleteAgreementButtonEnabled(element)" (click)="onDeleteAgreementClick(element)">
                        <mat-icon>delete</mat-icon>
                        {{ 'WAD-DeleteAgreement' | translate }}
                      </button>
                    </div>
                    } @if (isExtendAgreementButtonVisible(element.Status, element.AgreementTypeId, element.EmploymentTypeId)) {
                    <button
                      mat-menu-item
                      [visibleWithPermissionsOnWorkerProfile]="['ManageMyExternalWorkersList', 'ManageAllExternalWorkersList']"
                      [authServerUserId]="authServerUserId"
                      (click)="onExtendAgreementClick(element.AgreementId, element.WorkerId, element.EmploymentTypeId)"
                    >
                      <mat-icon>published_with_changes</mat-icon>
                      {{ 'ExtendAgreement' | translate }}
                    </button>
                    } @if (isReplaceAgreementButtonVisible(element.Status, element.EmploymentTypeId)) {
                    <button
                      mat-menu-item
                      (click)="replaceAgreement(element.AgreementId, element.WorkerId, element.EmploymentTypeId)"
                      [visibleWithPermissionsOnWorkerProfile]="['ReplaceAgreement']"
                      [authServerUserId]="authServerUserId"
                    >
                      <mat-icon>swap_horiz</mat-icon>
                      {{ 'ReplaceWorkerAgreement' | translate }}
                    </button>
                    } @if (isAddAnnexButtonVisible(element.Status)) {
                    <ng-template *hasPermissionToModule="moduleNames.Annex; workerId: element.WorkerId">
                      <button
                        mat-menu-item
                        [visibleWithPermissionsOnWorkerProfile]="['CreateAnnex']"
                        [authServerUserId]="authServerUserId"
                        (click)="onAddAnnexClick(element.AgreementId, element.WorkerId, element.EmploymentTypeId)"
                      >
                        <mat-icon>note_add</mat-icon>
                        {{ 'AddAnnex' | translate }}
                      </button>
                    </ng-template>
                    } @if (isTerminateButtonVisible(element.Status, element.EmploymentTypeId)) {
                    <button
                      mat-menu-item
                      (click)="
                        onTerminateClick(
                          element.WorkerId,
                          element.EmployerName,
                          element.AgreementId,
                          element.NoticePeriodId,
                          element.AgreementStartDate,
                          element.AgreementEndDate,
                          element.EmploymentTypeId,
                          element.HasAgreementTerminationReason
                        )
                      "
                    >
                      <mat-icon>highlight_off</mat-icon>
                      {{ 'TerminateAgreement' | translate }}
                    </button>
                    } @if (isShowAgreementButtonVisible(element.Status, element.IsImported)) {
                    <button
                      mat-menu-item
                      (click)="onShowAgreementClick(element.AgreementId)"
                      [visibleWithPermissions]="['AgreementPreview', 'AgreementPreviewAllExternalWorkers', 'AgreementPreviewMyExternalWorkers']"
                    >
                      <mat-icon>find_in_page</mat-icon>
                      {{ 'WL-ShowAgreementButton' | translate }}
                    </button>
                    } @if (isDownloadAgreementVisible(element.Status, element.IsImported)) {
                    <button
                      mat-menu-item
                      (click)="onDownloadAgreementClick(element.AgreementId)"
                      [visibleWithPermissions]="['AgreementPreview', 'AgreementPreviewAllExternalWorkers', 'AgreementPreviewMyExternalWorkers']"
                    >
                      <mat-icon>file_download</mat-icon>
                      {{ 'WL-DownloadAgreementButton' | translate }}
                    </button>
                    }
                  </mat-menu>
                  @if (hasAnyAction(element)) {
                  <button mat-button class="button-text" [matMenuTriggerFor]="employeeActionsMenu">
                    <span>{{ 'Actions' | translate }}</span>
                    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                  </button>
                  } } @else { @if (isEditAgreementButtonVisible(element.Status)) {
                  <button
                    mat-icon-button
                    matTooltip="{{ 'WL-EditWorkerAgreement' | translate }}"
                    matTooltipPosition="above"
                    matTooltipClass="agreements-tooltip"
                    (click)="onEditAgreementClick(element)"
                  >
                    <mat-icon class="material-icons-outlined">create</mat-icon>
                  </button>
                  } @if (!isWaitingForGenerationStatus(element.Status)) {
                  <button
                    [routerLink]="[
                      '/workers',
                      element.WorkerId,
                      'employmentType',
                      element.EmploymentTypeId,
                      'agreements',
                      element.AgreementId,
                      'details'
                    ]"
                    mat-icon-button
                    matTooltip="{{ 'WL-WorkerAgreementDetails' | translate }}"
                    matTooltipPosition="above"
                    matTooltipClass="agreements-tooltip"
                    [visibleWithPermissionsOnWorkerProfile]="['ManageMyExternalWorkersList', 'ViewAllExternalWorkers']"
                    [authServerUserId]="authServerUserId"
                  >
                    <mat-icon class="material-icons-outlined">visibility</mat-icon>
                  </button>
                  } @if (isExtendAgreementButtonVisible(element.Status, element.AgreementTypeId, element.EmploymentTypeId)) {
                  <button
                    mat-icon-button
                    [visibleWithPermissionsOnWorkerProfile]="['ManageMyExternalWorkersList', 'ManageAllExternalWorkersList']"
                    [authServerUserId]="authServerUserId"
                    (click)="onExtendAgreementClick(element.AgreementId, element.WorkerId, element.EmploymentTypeId)"
                    matTooltip="{{ 'ExtendAgreement' | translate }}"
                    matTooltipPosition="above"
                    matTooltipClass="agreements-tooltip"
                  >
                    <mat-icon class="material-icons-outlined">published_with_changes</mat-icon>
                  </button>
                  } @if (isReplaceAgreementButtonVisible(element.Status, element.EmploymentTypeId)) {
                  <button
                    mat-icon-button
                    [visibleWithPermissionsOnWorkerProfile]="['ReplaceAgreement']"
                    [authServerUserId]="authServerUserId"
                    (click)="replaceAgreement(element.AgreementId, element.WorkerId, element.EmploymentTypeId)"
                    matTooltip="{{ 'ReplaceWorkerAgreement' | translate }}"
                    matTooltipPosition="above"
                    matTooltipClass="agreements-tooltip"
                  >
                    <mat-icon class="material-icons-outlined">swap_horiz</mat-icon>
                  </button>
                  } @if (isTerminateButtonVisible(element.Status, element.EmploymentTypeId)) {
                  <button
                    mat-icon-button
                    (click)="
                      onTerminateClick(
                        element.WorkerId,
                        element.EmployerName,
                        element.AgreementId,
                        element.NoticePeriodId,
                        element.AgreementStartDate,
                        element.AgreementEndDate,
                        element.EmploymentTypeId,
                        element.HasAgreementTerminationReason
                      )
                    "
                    matTooltip="{{ 'TerminateAgreement' | translate }}"
                    matTooltipPosition="above"
                    matTooltipClass="agreements-tooltip"
                  >
                    <mat-icon>highlight_off</mat-icon>
                  </button>
                  } @if (isShowAgreementButtonVisible(element.Status, element.IsImported)) {
                  <button
                    mat-icon-button
                    (click)="onShowAgreementClick(element.AgreementId)"
                    matTooltip="{{ 'WL-ShowAgreementButton' | translate }}"
                    matTooltipPosition="above"
                    matTooltipClass="agreements-tooltip"
                    [visibleWithPermissions]="['AgreementPreview']"
                  >
                    <mat-icon class="material-icons-outlined">find_in_page</mat-icon>
                  </button>
                  } @if (isDownloadAgreementVisible(element.Status, element.IsImported)) {
                  <button
                    mat-icon-button
                    (click)="onDownloadAgreementClick(element.AgreementId)"
                    matTooltip="{{ 'WL-DownloadAgreementButton' | translate }}"
                    matTooltipPosition="above"
                    matTooltipClass="agreements-tooltip"
                    [visibleWithPermissions]="['AgreementPreview']"
                  >
                    <mat-icon class="material-icons-outlined">file_download</mat-icon>
                  </button>
                  } }
                </div>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              tabindex="0"
              [class.row--active]="row.AgreementId === activeAnnexAgreementId"
              (click)="openAnnexesPanel(row)"
              (keydown.enter)="openAnnexesPanel(row)"
              (keydown.space)="$event.preventDefault(); openAnnexesPanel(row)"
            ></mat-row>
          </mat-table>
        </div>
        <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
</app-split>
